"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowActionResetRepurchaseCounter = exports.flowActionToggleRule = exports.flowActionSetRuleLimit = exports.getFlowActivityRuleSummary = exports.enrichFlowActivity = exports.getFlowActivity = exports.updateFlowStatus = exports.getFlowStatus = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Shopify Flow automations status for the current shop — emit toggle, Pro gate, this-hour dropped-trigger count
*/
const getFlowStatus = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/status`, method: 'get'
    });
};
exports.getFlowStatus = getFlowStatus;
/**
* @summary Turn Shopify Flow trigger emission on/off for the current shop (Pro only)
*/
const updateFlowStatus = (updateFlowStatusDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/status`, method: 'patch',
        headers: { 'Content-Type': 'application/json', },
        data: updateFlowStatusDto
    });
};
exports.updateFlowStatus = updateFlowStatus;
/**
* @summary Recent Shopify Flow trigger/action activity for the current shop — what was sent/received, and why anything was skipped or rejected
*/
const getFlowActivity = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/activity`, method: 'get',
        params
    });
};
exports.getFlowActivity = getFlowActivity;
/**
* @summary Resolve one activity row's customer/product/order references into display names — fetched live, on demand
*/
const enrichFlowActivity = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/activity/${id}/enrich`, method: 'get'
    });
};
exports.enrichFlowActivity = enrichFlowActivity;
/**
* @summary Aggregate Flow automation stats for one rule — outcome tiles, a why-it's-(not)-firing breakdown, top products, and a daily trend
*/
const getFlowActivityRuleSummary = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/activity/rule-summary`, method: 'get',
        params
    });
};
exports.getFlowActivityRuleSummary = getFlowActivityRuleSummary;
/**
* @summary Shopify Flow action: adjust one bound of an existing rule
*/
const flowActionSetRuleLimit = (setRuleLimitRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/actions/set-rule-limit`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: setRuleLimitRequestDto
    });
};
exports.flowActionSetRuleLimit = flowActionSetRuleLimit;
/**
* @summary Shopify Flow action: enable/disable an existing rule
*/
const flowActionToggleRule = (toggleRuleRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/actions/toggle-rule`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: toggleRuleRequestDto
    });
};
exports.flowActionToggleRule = flowActionToggleRule;
/**
* @summary Shopify Flow action: clear a customer's repurchase counter for a rule
*/
const flowActionResetRepurchaseCounter = (resetRepurchaseCounterRequestDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/flow/actions/reset-repurchase-counter`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: resetRepurchaseCounterRequestDto
    });
};
exports.flowActionResetRepurchaseCounter = flowActionResetRepurchaseCounter;
